$(document).ready(function(){

  $(document).on("click",function(event) {
    if(!event.target.closest('#profile-dropdown') && !event.target.closest(".profile-link")) {
      $("#profile-dropdown").removeClass("show")
    }
    if(!event.target.closest('.responsive_mobile_menu.menu_area')) {
      $('.responsive-menu').addClass('canvas-menu');
      $('body').removeClass("overflow-hidden");
    }
    if($(event.target).hasClass("wishlist-darkbg")) {
      $("#wishlistSide").css("transform", "translateX(100%)");
      $(".wishlist-darkbg").removeClass("wishlist-darkbg--is-visible");      
    }
  });
  
  setTimeout(function() {
    $("#page-loader").css("display","none");
    $("#form-loader").css("display","block");
    
    $('.item_CC_KT').click(function() {
      var code = $(this).data('value');
      if(code === 'INR'){
        window.location.href = "https://hemant-nandita-india.myshopify.com";
      }
  	});
  }, 2000);
  
  /**Redirect to HNN INDIA**/
  
  
  $('.action_bottom .btn-secondary').click(function () {
    location.reload();
  });
  
  $('#search-btn').click(function() {
  	if(window.innerWidth < 768){
      $(".bc-sf-search-suggestion-mobile-top-panel").show();
    }
  });
  $(".menu-mob").click(function(){
    $(this).toggleClass("down-mob");
    $(this).next(".child-mobile").slideToggle();
  });
  $(".menu-mob2").click(function(){
      $(this).toggleClass("down-mob");
      $(this).next(".grandchild-mobile").slideToggle();
  });    
 });


/* All Videos */
$('.myvideo').parent().click(function () {
    if($(this).children(".myvideo").get(0).paused){
      $(this).children(".myvideo").get(0).play();
      $(this).children(".playpause").fadeOut();
      }
      else{       
        $(this).children(".myvideo").get(0).pause();
        $(this).children(".playpause").fadeIn();
      }
  });

$(document).ready(function(){
  
/*Carousel Home Page New Arrivals*/ 
    $('.carousel-main').owlCarousel({
     items: 3,
     loop: true,
     autoplay: false,
     margin: 25,
     nav: false,
     dots: false,
     lazyLoad: true, 
   responsive:{
             0:{
                 items:2
             },
             600:{
                 items:2
             },
             1000:{
                 items:3
             }
         }
 })
 var owl = $('.owl-carousel');
 owl.owlCarousel();
 // Go to the next item
 $('.next').click(function() {
   console.log('next');
     owl.trigger('next.owl.carousel');
 })
 // Go to the previous item
 $('.prev').click(function() {
   console.log('prev');
     // With optional speed parameter
     // Parameters has to be in square bracket '[]'
     owl.trigger('prev.owl.carousel', [300]);
 })
 

// blur on menu
$(".blur").mouseover(function() {
    $("main").css("filter", "blur(5px)");
  });

  $(".blur").mouseout(function() {
    $("main").css("filter", "none");
  });
});

/* Product Page*/

$(document).on("click", "[data-change-option]", function(e) {
    e.preventDefault();
    var optionIndex = parseInt($(this).data("changeOption")),
      optionValue = $(this).data("changeValue");
    if (
      optionSelectors.optionExistInSelect(
        optionSelectors.selectors[optionIndex].element,
        optionValue
      )
    ) {
      $(optionSelectors.selectors[optionIndex].element)
        .val(optionValue)
        .trigger("change");
    }
  });


$("#dhlZone").on("show.bs.modal", function() {
  $("main").addClass("blur");
});

$("#dhlZone").on("hide.bs.modal", function() {
  $("main").removeClass("blur");
});


/*------------------------------ for search ---------------------*/

$(document).ready(function() {
  if ($(".search-field").val() != "") {
    $(".search-field").focus();
    $(".search-field").focusout(function() {
      $(".search-field").focus();
    });
  }
});

/* -------------------------- Mobile footer accordion------------------------ */

$(".mobile_footer_title").click(function() {
  $(this)
    .next(".footer_list")
    .slideToggle();
  $(this)
    .find(".arrow-footer")
    .toggleClass("rotate-arrow");
});
$(".accordion").click(function() {
  $(this)
    .siblings(".accordion")
    .find(".footer_list")
    .hide();

  if (
    $(this)
      .siblings(".accordion")
      .find(".arrow-footer")
      .hasClass("rotate-arrow")
  ) {
    $(this)
      .siblings(".accordion")
      .find(".arrow-footer")
      .removeClass("rotate-arrow");
  }
});


/* -------------------------- Swatch Collection Resort------------------------ */
jQuery.fn.select2OptionPicker = function(options) {
    return this.each(function() {
        var $ = jQuery;
        var select = $(this);
        var multiselect = select.attr('multiple');
        select.hide();

        var buttonsHtml = $('<div class="select2OptionPicker"></div>');
        var selectIndex = 0;
        var addOptGroup = function(optGroup) {
            if (optGroup.attr('label')) {
                buttonsHtml.append('<strong>' + optGroup.attr('label') + '</strong>');
            }
            var ulHtml = $('<ul class="select-buttons">');
            optGroup.children('option').each(function() {
                var img_src = $(this).data('img-src');
                var color = $(this).data('color');

                var liHtml = $('<li></li>');
                if ($(this).attr('disabled') || select.attr('disabled')) {
                    liHtml.addClass('disabled');
                    liHtml.append('<span>' + $(this).html() + '</span>');
                } else {

                    if (color) {
                        liHtml.append('<a href="#" style="background-color:' + color + '" data-select-index="' + selectIndex + '">&nbsp;</a>');
                    } else if (img_src) {
                        liHtml.append('<a href="#" data-select-index="' + selectIndex + '"><img class="image_picker" src="' + img_src + '"></a>');
                    } else {
                        liHtml.append('<a href="#" data-select-index="' + selectIndex + '">' + $(this).html() + '</a>');
                    }
                }

                // Mark current selection as "picked"
                if ((!options || !options.noDefault) && $(this).attr('selected')) {
                    liHtml.children('a, span').addClass('picked');
                }
                ulHtml.append(liHtml);
                selectIndex++;
            });
            buttonsHtml.append(ulHtml);
        }

        var optGroups = select.children('optgroup');
        if (optGroups.length == 0) {
            addOptGroup(select);
        } else {
            optGroups.each(function() {
                addOptGroup($(this));
            });
        }

        select.after(buttonsHtml);

        buttonsHtml.find('a').click(function(e) {
            e.preventDefault();
            var clickedOption = $(select.find('option')[$(this).attr('data-select-index')]);
            if (multiselect) {
                if (clickedOption.attr('selected')) {
                    $(this).removeClass('picked');
                    clickedOption.removeAttr('selected');
                } else {
                    $(this).addClass('picked');
                    clickedOption.attr('selected', 'selected');
                }
            } else {
                if ($(this).hasClass('picked')) {
                    $(this).removeClass('picked');
                    clickedOption.removeAttr('selected');
                } else {
                    buttonsHtml.find('a, span').removeClass('picked');
                    $(this).addClass('picked');
                    clickedOption.attr('selected', 'selected');
                }
            }
            select.trigger('change');
        });
    });
};
